import type { SubscriptionActionView } from './api';

export function isPendingSettlement(view: SubscriptionActionView): boolean {
  return view.payment?.status === 'PENDING' && view.invoice?.status === 'PROCESSING';
}
